export const cardsData = [
  {
    id: 1,
    title: "某顶流小生深夜密会画面曝光，工作室紧急发声明",
    category: "独家爆料",
    summary: "近日有媒体拍到某当红男星深夜与神秘女子共同出入某高档酒店，两人举止亲密引发热议。工作室凌晨紧急发布声明称系剧组聚会，但网友扒出诸多疑点。",
    date: "2026-07-29",
    tag: "顶流塌房",
    image: "https://readdy.ai/api/search-image?query=Paparazzi%20night%20photography%20scene%20of%20a%20Chinese%20celebrity%20entering%20a%20luxury%20hotel%2C%20dramatic%20lighting%2C%20blurry%20candid%20shot%2C%20dark%20atmosphere%2C%20editorial%20photojournalism%20style%2C%20warm%20street%20light%20tones&width=800&height=500&seq=card-1&orientation=landscape",
  },
  {
    id: 2,
    title: "综艺录制现场打架事件真相曝光，节目组导演已离职",
    category: "内幕深扒",
    summary: "某热门综艺节目录制期间，两位常驻嘉宾因游戏环节产生口角继而发生肢体冲突，节目组疑似压热搜。知情人士透露涉事嘉宾已私下和解。",
    date: "2026-07-28",
    tag: "综艺风波",
    image: "https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20dramatic%20tension%2C%20empty%20chairs%20and%20microphones%20on%20a%20variety%20show%20stage%2C%20spotlights%20casting%20shadows%2C%20behind%20the%20scenes%20atmosphere%2C%20dark%20mood%2C%20professional%20broadcast%20environment&width=800&height=500&seq=card-2&orientation=landscape",
  },
  {
    id: 3,
    title: "女星整容翻车现场照流出，医美机构被指违规操作",
    category: "热点追踪",
    summary: "一组某知名女星术后恢复期的素颜照在网上疯传，面部肿胀明显与往日判若两人。涉事医美机构被指未取得相关资质，目前已被监管部门立案调查。",
    date: "2026-07-27",
    tag: "整容翻车",
    image: "https://readdy.ai/api/search-image?query=Modern%20plastic%20surgery%20clinic%20exterior%20at%20night%2C%20medical%20building%20with%20dramatic%20lighting%2C%20luxury%20aesthetic%20clinic%20facade%2C%20mysterious%20atmosphere%2C%20warm%20interior%20glow%20through%20windows%2C%20editorial%20photography&width=800&height=500&seq=card-3&orientation=landscape",
  },
  {
    id: 4,
    title: "知名导演被曝选角潜规则，多位女演员站出发声",
    category: "行业黑幕",
    summary: "近日多位女演员在社交平台发声，指控某知名导演在选角过程中存在不当行为。引发全网热议，话题阅读量突破5亿。业内人士呼吁建立行业自律机制。",
    date: "2026-07-26",
    tag: "潜规则",
    image: "https://readdy.ai/api/search-image?query=Film%20director%20chair%20on%20empty%20movie%20set%2C%20spotlight%20casting%20dramatic%20shadows%2C%20clapperboard%20on%20the%20ground%2C%20dark%20cinematic%20atmosphere%2C%20professional%20film%20production%20environment%2C%20moody%20lighting&width=800&height=500&seq=card-4&orientation=landscape",
  },
  {
    id: 5,
    title: "某男团成员涉嫌税务问题被调查，经纪公司股价暴跌",
    category: "法制前沿",
    summary: "税务部门已正式对某男团当红成员展开调查，涉及金额或达千万级别。消息传出后其所属经纪公司股价连续三日跌停，多个代言品牌已暂停合作。",
    date: "2026-07-25",
    tag: "税务风波",
    image: "https://readdy.ai/api/search-image?query=Financial%20document%20and%20legal%20papers%20on%20a%20dark%20desk%2C%20dramatic%20shadow%20from%20window%20blinds%2C%20tax%20investigation%20theme%2C%20serious%20atmosphere%2C%20warm%20desk%20lamp%20light%2C%20editorial%20photography&width=800&height=500&seq=card-5&orientation=landscape",
  },
];

export const aboutData = {
  title: "关于每日吃瓜",
  description: "每日吃瓜是国内领先的娱乐资讯深度解读平台，专注于为吃瓜群众提供最新、最全、最深入的明星黑料、娱乐圈黑幕和黑历史曝光内容。自上线以来，我们始终秉持\"让真相不再沉默\"的理念，用事实说话，以证据服人。",
  highlights: [
    "每日更新最新娱乐圈爆点和明星丑闻",
    "深度扒皮暗黑历史，还原真相不遮掩",
    "全网汇总黑料合集，一站式吃瓜体验",
  ],
  stats: [
    { label: "日均爆料", value: "50+" },
    { label: "独家线索", value: "2000+" },
    { label: "吃瓜群众", value: "800万+" },
  ],
};

export const carouselData = [
  {
    id: 1,
    title: "2026娱乐圈半年报：塌房明星大盘点",
    category: "半年总结",
    summary: "2026年上半年娱乐圈风云变幻，多位一线明星因各种丑闻跌落神坛。从税务问题到私生活混乱，从违法失德到人设崩塌，我们为你梳理这半年来最劲爆的塌房事件，看看哪些明星从顶流沦为过街老鼠。",
    image: "https://readdy.ai/api/search-image?query=Broken%20mirror%20fragments%20reflecting%20spotlights%20on%20a%20dark%20stage%20floor%2C%20fallen%20microphone%20stand%2C%20dramatic%20theater%20curtains%2C%20ruins%20aesthetic%2C%20warm%20golden%20and%20crimson%20tones%2C%20cinematic%20lighting%2C%20high%20contrast&width=1200&height=600&seq=carousel-1&orientation=landscape",
  },
  {
    id: 2,
    title: "选秀黑幕大起底：那些年被偷走的人生",
    category: "深度专题",
    summary: "从投票造假到内定出道，从合同陷阱到天价违约金，选秀节目的光鲜背后究竟藏着多少不为人知的秘密？我们深入调查了近年来最具争议的选秀丑闻，揭开造星流水线上的层层黑幕。",
    image: "https://readdy.ai/api/search-image?query=Empty%20talent%20show%20stage%20with%20scattered%20voting%20cards%20and%20ripped%20posters%2C%20dim%20spotlights%2C%20behind%20the%20scenes%20darkness%2C%20dramatic%20contrast%2C%20editorial%20style%2C%20warm%20golden%20accents&width=1200&height=600&seq=carousel-2&orientation=landscape",
  },
  {
    id: 3,
    title: "豪门婚姻翻车实录：闪婚闪离背后的真相",
    category: "情感深扒",
    summary: "表面光鲜的豪门婚姻，实则暗流涌动。从婚前协议到财产分割，从出轨传闻到家暴指控，我们整理了近年来最具话题性的明星婚姻翻车案例，带你看清豪门背后的真实面目。",
    image: "https://readdy.ai/api/search-image?query=Shattered%20wedding%20ring%20on%20marble%20floor%2C%20torn%20wedding%20invitation%2C%20luxurious%20but%20cold%20atmosphere%2C%20dramatic%20shadow%20play%2C%20dark%20elegance%2C%20warm%20gold%20and%20crimson%20tones%2C%20editorial%20photography&width=1200&height=600&seq=carousel-3&orientation=landscape",
  },
  {
    id: 4,
    title: "明星代言翻车史：那些年被坑的品牌方",
    category: "商业内幕",
    summary: "明星塌房，品牌遭殃。当千万代言费打了水漂，当品牌形象一夜崩塌，这些血泪教训值得所有品牌警醒。我们盘点了近五年最具代表性的明星代言翻车事件及其天价赔偿。",
    image: "https://readdy.ai/api/search-image?query=Torn%20luxury%20brand%20posters%20and%20broken%20billboard%20on%20the%20ground%2C%20city%20night%20background%2C%20neon%20lights%2C%20dramatic%20urban%20scene%2C%20commercial%20collapse%20aesthetic%2C%20warm%20streetlight%20glow&width=1200&height=600&seq=carousel-4&orientation=landscape",
  },
  {
    id: 5,
    title: "饭圈战争全记录：粉丝互撕的终极代价",
    category: "生态观察",
    summary: "从微博热搜到线下冲突，从P遗照到人肉搜索，饭圈互撕已经远远超出了追星的范畴。我们回顾了近年来最激烈的几场饭圈大战，探讨饭圈文化对社会生态的深远影响。",
    image: "https://readdy.ai/api/search-image?query=Scattered%20fan%20lightsticks%20and%20banners%20on%20empty%20concert%20ground%2C%20conflict%20aftermath%2C%20dramatic%20stadium%20lighting%2C%20dark%20evening%20atmosphere%2C%20warm%20golden%20and%20red%20accents%2C%20editorial%20photojournalism&width=1200&height=600&seq=carousel-5&orientation=landscape",
  },
];

export const featuresData = [
  {
    id: 1,
    icon: "ri-flashlight-line",
    title: "独家线索挖掘",
    description: "拥有业内最广泛的信息渠道和线人网络，第一时间获取娱乐圈最新内幕和独家爆料，让你吃到最新鲜的第一口瓜。",
  },
  {
    id: 2,
    icon: "ri-search-eye-line",
    title: "深度事实核查",
    description: "每一条爆料的背后都有严谨的事实核查流程，多方交叉验证信息来源，确保呈现给你的是经过核实的高质量黑料内容。",
  },
  {
    id: 3,
    icon: "ri-group-line",
    title: "全网资讯聚合",
    description: "实时监控各大社交平台和娱乐媒体，将散落全网的热门瓜料集中整理，让你一个页面就能掌握今日全部娱乐圈动态。",
  },
];

export const contactData = {
  title: "爆料投稿",
  description: "你有独家黑料线索？发现娱乐圈不为人知的秘密？欢迎通过以下方式联系我们，我们将严格保护爆料人隐私，让每一个真相都得到公正呈现。",
  email: "tips@meirichigua.com",
  wechat: "meirichigua_tips",
  note: "所有投稿均采用匿名处理，严格保护爆料人身份信息。提供真实可靠线索者将获得丰厚报酬。",
};

export const updatesData = [
  {
    id: 1,
    time: "2026-07-30 14:32",
    title: "某女星被拍到孕期在酒吧通宵狂欢，已删除社交媒体所有内容",
    tag: "最新",
  },
  {
    id: 2,
    time: "2026-07-30 11:15",
    title: "知名综艺导演被实名举报性骚扰，多名前员工站出指证",
    tag: "突发",
  },
  {
    id: 3,
    time: "2026-07-30 09:48",
    title: "当红流量明星被品牌方集体解约，涉及金额过亿",
    tag: "重磅",
  },
  {
    id: 4,
    time: "2026-07-29 22:10",
    title: "某歌手演唱会假唱实锤，现场音频对比视频引爆网络",
    tag: "实锤",
  },
  {
    id: 5,
    time: "2026-07-29 18:25",
    title: "娱乐圈大佬被限制出境，名下多家公司已注销",
    tag: "追踪",
  },
  {
    id: 6,
    time: "2026-07-29 15:07",
    title: "某选秀冠军涉嫌学历造假，毕业院校回应称无此人",
    tag: "翻车",
  },
  {
    id: 7,
    time: "2026-07-29 10:33",
    title: "两家经纪公司为抢新人闹上法庭，合同纠纷细节曝光",
    tag: "内幕",
  },
  {
    id: 8,
    time: "2026-07-28 20:41",
    title: "某综艺节目录制现场发生安全事故，三名工作人员受伤",
    tag: "安全",
  },
  {
    id: 9,
    time: "2026-07-28 16:59",
    title: "当红小花被爆私生活混乱，前经纪人发文暗讽",
    tag: "吃瓜",
  },
];

export const rankingData = [
  {
    rank: 1,
    title: "顶流男星深夜密会事件持续发酵",
    hot: "9823万",
    change: "hot",
  },
  {
    rank: 2,
    title: "选秀冠军学历造假真相大揭秘",
    hot: "8751万",
    change: "up",
  },
  {
    rank: 3,
    title: "知名导演选角潜规则多位女星发声",
    hot: "7624万",
    change: "up",
  },
  {
    rank: 4,
    title: "某男团成员税务问题调查新进展",
    hot: "6892万",
    change: "down",
  },
  {
    rank: 5,
    title: "综艺录制现场打架事件内幕深扒",
    hot: "5213万",
    change: "up",
  },
];

export const faqData = [
  {
    id: 1,
    question: "每日吃瓜的爆料信息可靠吗？",
    answer: "我们所有发布的爆料内容均经过至少两个独立信源的交叉验证。虽然娱乐圈信息复杂多变，但我们始终坚持\"无证据不发布\"的原则，对有争议的信息会明确标注\"传闻\"或\"待证实\"标签，让读者自行判断。同时我们建立了完善的更正机制，一旦发现信息有误，会第一时间发布更正声明。",
  },
  {
    id: 2,
    question: "如何向每日吃瓜投稿爆料？",
    answer: "可以通过页面上方的投稿邮箱或微信联系我们。我们承诺对爆料人信息进行严格加密和匿名处理，采用端到端加密通信确保信息安全。提供经核实的独家有效线索的爆料人，将根据信息价值获得相应报酬。请放心，你的身份只有系统知道。",
  },
  {
    id: 3,
    question: "为什么有些爆料会被删除？",
    answer: "爆料内容被删除通常有两种情况：一是我们在后续核查中发现信息有误或证据不足，主动下架以确保内容质量；二是涉及正在进行的司法调查，在案件有明确结论前我们会暂停相关内容展示。我们从不因外部压力删除真实报道。",
  },
  {
    id: 4,
    question: "每日吃瓜的内容更新频率是怎样的？",
    answer: "我们保持7x24小时全天候更新，每天至少推送20条以上的新鲜爆料。重大突发事件发生时，我们会在30分钟内发布初步信息，并在2小时内完成深度报道。同时每个工作日早上8点准时发布今日吃瓜早报，为你一站式汇总过去24小时的热门瓜料。",
  },
  {
    id: 5,
    question: "被爆料的人可以要求删除内容吗？",
    answer: "如果当事人认为我们的报道存在事实性错误，欢迎通过官方渠道提交书面更正申请和相关证明材料。我们会在收到申请后24小时内启动事实核查程序。如果确认信息有误，我们会及时更正并致歉。但我们不会基于公关压力或利益交换删除经核实的真实报道。",
  },
];

export const topicsData = [
  { id: 1, name: "顶流塌房", count: "1.2亿", hot: true },
  { id: 2, name: "综艺翻车", count: "8923万", hot: true },
  { id: 3, name: "选秀黑幕", count: "7654万", hot: true },
  { id: 4, name: "明星税务", count: "6543万", hot: false },
  { id: 5, name: "整容翻车", count: "5432万", hot: false },
  { id: 6, name: "饭圈大战", count: "4987万", hot: false },
  { id: 7, name: "豪门婚姻", count: "4321万", hot: false },
  { id: 8, name: "导演潜规则", count: "3890万", hot: false },
  { id: 9, name: "代言翻车", count: "3567万", hot: false },
  { id: 10, name: "假唱实锤", count: "3123万", hot: false },
  { id: 11, name: "学历造假", count: "2890万", hot: false },
];

export const indexData = [
  {
    id: 1,
    title: "顶流明星塌房全记录",
    description: "收录近三年所有塌房明星事件完整档案",
    count: "47篇",
    icon: "ri-article-line",
  },
  {
    id: 2,
    title: "综艺节目黑幕揭秘",
    description: "深度调查热门综艺背后的暗箱操作",
    count: "32篇",
    icon: "ri-tv-line",
  },
  {
    id: 3,
    title: "明星情感纠纷专题",
    description: "娱乐圈爱恨情仇完整时间线梳理",
    count: "56篇",
    icon: "ri-emotion-sad-line",
  },
  {
    id: 4,
    title: "娱乐行业潜规则",
    description: "从选角到合同，揭露行业灰色地带",
    count: "28篇",
    icon: "ri-file-warning-line",
  },
  {
    id: 5,
    title: "明星违法失德档案",
    description: "涉法涉事明星案件进展与判决汇总",
    count: "19篇",
    icon: "ri-scales-line",
  },
  {
    id: 6,
    title: "品牌代言翻车史",
    description: "那些被明星连累的品牌血泪史",
    count: "23篇",
    icon: "ri-building-line",
  },
  {
    id: 7,
    title: "饭圈文化深观察",
    description: "粉丝经济背后的社会学分析",
    count: "35篇",
    icon: "ri-user-heart-line",
  },
  {
    id: 8,
    title: "医美翻车案例集",
    description: "明星整容失败的教训与警示",
    count: "15篇",
    icon: "ri-syringe-line",
  },
  {
    id: 9,
    title: "娱乐资本局解密",
    description: "资本运作背后的娱乐圈利益链",
    count: "41篇",
    icon: "ri-money-cny-circle-line",
  },
];

export const mediaData = [
  {
    id: 1,
    title: "独家对话：前娱乐记者揭秘行业黑幕",
    type: "访谈",
    duration: "28:45",
    thumbnail: "https://readdy.ai/api/search-image?query=Professional%20interview%20setup%20with%20empty%20chairs%20and%20microphones%20in%20a%20dimly%20lit%20studio%2C%20warm%20spotlight%2C%20dramatic%20atmosphere%2C%20interview%20program%20set%2C%20professional%20broadcast%20environment%2C%20dark%20background&width=800&height=450&seq=media-1&orientation=landscape",
  },
  {
    id: 2,
    title: "深度解析：2026上半年塌房明星TOP10",
    type: "盘点",
    duration: "15:20",
    thumbnail: "https://readdy.ai/api/search-image?query=Falling%20stars%20and%20broken%20trophies%20on%20a%20dark%20stage%2C%20dramatic%20red%20curtain%20background%2C%20countdown%20visual%2C%20award%20show%20aftermath%2C%20cinematic%20lighting%2C%20editorial%20style%2C%20warm%20golden%20accents&width=800&height=450&seq=media-2&orientation=landscape",
  },
  {
    id: 3,
    title: "快速复盘：某顶流男星72小时塌房全过程",
    type: "专题",
    duration: "22:10",
    thumbnail: "https://readdy.ai/api/search-image?query=Breaking%20news%20studio%20with%20dramatic%20red%20lighting%2C%20countdown%20clock%2C%20empty%20anchor%20desk%2C%20urgent%20news%20atmosphere%2C%20broadcast%20journalism%20style%2C%20dark%20and%20warm%20tones%2C%20professional%20set&width=800&height=450&seq=media-3&orientation=landscape",
  },
];

export const commentsData = [
  {
    id: 1,
    avatar: "https://readdy.ai/api/search-image?query=Anonymous%20silhouette%20portrait%20on%20dark%20background%2C%20mysterious%20figure%2C%20no%20face%20visible%2C%20warm%20lighting%20from%20behind%2C%20simple%20profile&width=80&height=80&seq=avatar-1&orientation=squarish",
    nickname: "资深吃瓜群众",
    time: "2小时前",
    content: "这个瓜我吃了三天了，越挖越深啊！没想到背后还有这么多隐情，感觉比电视剧还精彩。坐等更多实锤！",
    likes: 3281,
  },
  {
    id: 2,
    avatar: "https://readdy.ai/api/search-image?query=Anonymous%20dark%20silhouette%20of%20a%20person%20against%20warm%20glow%2C%20mysterious%20unknown%20figure%2C%20no%20facial%20features%2C%20backlit%20portrait%2C%20editorial%20style&width=80&height=80&seq=avatar-2&orientation=squarish",
    nickname: "圈内知情人士",
    time: "5小时前",
    content: "作为半个圈内人，只能说这篇报道还只是冰山一角。有些事情比你们想象的复杂得多，涉及的利益关系网太大了。",
    likes: 5642,
  },
  {
    id: 3,
    avatar: "https://readdy.ai/api/search-image?query=Dark%20mysterious%20silhouette%20profile%20with%20warm%20backlight%2C%20anonymous%20portrait%2C%20hidden%20identity%2C%20no%20face%2C%20simple%20clean%20aesthetic&width=80&height=80&seq=avatar-3&orientation=squarish",
    nickname: "吃瓜不忘种瓜人",
    time: "8小时前",
    content: "每日吃瓜真的是我每天的快乐源泉！现在的内娱太需要这样的平台了，撕开那些虚伪的面具，让大家看看真实的娱乐圈。",
    likes: 2198,
  },
  {
    id: 4,
    avatar: "https://readdy.ai/api/search-image?query=Mysterious%20silhouette%20against%20warm%20golden%20light%2C%20anonymous%20profile%2C%20unknown%20person%2C%20no%20face%20visible%2C%20backlit%20portrait%2C%20simple%20editorial%20style&width=80&height=80&seq=avatar-4&orientation=squarish",
    nickname: "真相只有一个",
    time: "12小时前",
    content: "每天准时来打卡！这个平台的料真的又快又准，比那些整天发通稿的娱乐号强多了。给编辑加鸡腿！🍗",
    likes: 1876,
  },
];

export const appData = {
  title: "每日吃瓜 App — 随身吃瓜神器",
  description: "下载每日吃瓜App，随时随地获取最新娱乐爆料。推送比推送还快，吃瓜永远快人一步。支持iOS和Android双平台，更有独家深度内容和离线阅读功能。",
  features: ["实时推送", "离线阅读", "独家专题", "社区互动"],
  iosBadge: "App Store 即将上线",
  androidBadge: "Google Play 即将上线",
};

export const navItems = [
  { label: "首页", href: "#hero" },
  { label: "吃瓜App", href: "#app" },
  { label: "关于我们", href: "#about" },
  { label: "独家视频", href: "#media" },
  { label: "热门话题", href: "#topics" },
  { label: "吃瓜热榜", href: "#ranking" },
];